import { Navigate, useLocation } from 'react-router-dom';

/**
 * Sends a tab's bare URL to its default subtab KEEPING the query string, so the
 * deep links other tickets build on the tab survive the redirect:
 * `activity?event=…`, `activity?new=note` (CT-5724), `intelligence?item=…`
 * (CT-5715).
 */
function SubtabIndexRedirect({ to }) {
  const { search } = useLocation();
  return <Navigate to={{ pathname: to, search }} replace />;
}

export default SubtabIndexRedirect;
